/********Main payment tab button click event*********** */
// document.querySelectorAll('.section-pay-tab #tabs-nav .tablist').forEach(function(tab) {
//   tab.addEventListener('click', function() {
 
//       // Remove the 'active' class from all tabs
//       document.querySelectorAll('.section-pay-tab .tablist').forEach(function(tabitm) {
//           tabitm.classList.remove('active');
//       });

//       // Add the 'active' class to the clicked tab
//       tab.classList.add('active');

//       // Get the description ID from the clicked tab
//       var descriptionid = tab.getAttribute('data-descriptionid');

//       // Hide all content elements
//       document.querySelectorAll('.section-pay-tab .blkcol').forEach(function(content) {
//           content.style.display = 'none';
//       });

//       // Show the content with the matching data-content attribute
//       var matchingContent = document.querySelector('.section-pay-tab .blkcol[data-content="' + descriptionid + '"]');
//       if (matchingContent) {
//           matchingContent.style.display = 'block';
//       }

//       // Hide all footer content elements
//       document.querySelectorAll('.section-pay-tab .blkcolcontent').forEach(function(content) {
//           content.style.display = 'none';
//       });

//       // Show the content with the matching data-footer attribute
//       var matchingFooter = document.querySelector('.section-pay-tab .blkcolcontent[data-footer="' + descriptionid + '"]');
//       if (matchingFooter) {
//           matchingFooter.style.display = 'block';
//       }
//   });
// });


setTimeout(function() {
  var index = 0;
  var totalTabs = $('ul#tabs-nav li.tablist').length;
  var intervalId;

  function cycleTabs() {        
      $('ul#tabs-nav li.tablist').removeClass('active');        
      $('ul#tabs-nav li.tablist').eq(index).addClass('active'); 
      var tab_con =   $('ul#tabs-nav li.tablist.active').attr('data-descriptionid'); 
      $('.tab-content .blkcol').hide();
      $('.tab-content .blkcol[data-content='+tab_con+']').show();   
      index++;       
      if (index >= totalTabs) {
          index = 0;
      }
  }

  // Start cycling tabs
  intervalId = setInterval(function() {
      cycleTabs();
  }, 4000);

  // Initial cycle
  cycleTabs();

  // Click event to break the cycle and handle tab content
  document.querySelectorAll('.section-pay-tab #tabs-nav .tablist').forEach(function(tab) {
      tab.addEventListener('click', function() {
          // Stop the tab cycling animation
          clearInterval(intervalId);

          // Remove the 'active' class from all tabs
          document.querySelectorAll('.section-pay-tab #tabs-nav .tablist').forEach(function(tabitm) {
              tabitm.classList.remove('active');
          });

          // Add the 'active' class to the clicked tab
          tab.classList.add('active');

          // Get the description ID from the clicked tab
          var descriptionid = tab.getAttribute('data-descriptionid');

          // Hide all content elements
          document.querySelectorAll('.section-pay-tab .blkcol').forEach(function(content) {
              content.style.display = 'none';
          });

          // Show the content with the matching data-content attribute
          var matchingContent = document.querySelector('.section-pay-tab .blkcol[data-content="' + descriptionid + '"]');
            if (matchingContent) {
                matchingContent.style.display = 'block';

                // Calculate the position to scroll to with an extra 100px offset
                const offsetPosition = matchingContent.offsetTop - 130;

                // Smoothly scroll to the desired position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }


          // Hide all footer content elements
          document.querySelectorAll('.section-pay-tab .blkcolcontent').forEach(function(content) {
              content.style.display = 'none';
          });

          // Show the content with the matching data-footer attribute
          var matchingFooter = document.querySelector('.section-pay-tab .blkcolcontent[data-footer="' + descriptionid + '"]');
          if (matchingFooter) {
              matchingFooter.style.display = 'block';
          }
      });
  });

}, 1500);



// Trigger the click event on the first tab by default
// document.querySelector('.section-pay-tab #tabs-nav .tablist:nth-child(1)').click();




document.addEventListener('DOMContentLoaded', function() {
    // Get all the elements with class 'scroll-link'
    var show_payment_text = document.querySelectorAll('.show_payment_text');
  
    // Loop through all links
    show_payment_text.forEach(function(link) {
      link.addEventListener('click', function(e) {
        // Prevent the default behavior (no URL change)
        e.preventDefault();
  
        // Get the target element ID from the href attribute
        var targetId = link.getAttribute('href');
        var targetElement = document.querySelector(targetId);
  
        // Smooth scroll to the target element
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });
  });



document.addEventListener('click', function(e) {
    // Check if the clicked element matches the selector for .foot-btn
    if (e.target.matches('.section-pay-tab .tab-d-design2 .foot-btn')) {
        e.preventDefault(); 


        var button = document.querySelector('.tab-d-design2 .d-left-footer #pt-finance-page button.pt-button.pt-h4');
        if (button) {
            button.click(); // Trigger the click event
        }
    }
});



